import './MapCMGeometries.less';
import { Layer, Marker, Source } from 'react-map-gl';
import { Feature } from '../../../models/Geoserver';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import {
  FeatureSelectedMode, removeFeatureSelected,
  selectFeatureSelected,
  selectFeatureSelectedMode,
  selectTaskFeatures,
} from '../../../store/slice/mapLayersSlice';
import { useMemo } from 'react';
import { getTopRightCoordinate } from '../../../utils/GeometryUtils';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as Remove } from '../../../res/svg/remove-outlined.svg';

function MapCMGeometries() {

  const features: Feature[] = useAppSelector(
    selectTaskFeatures,
  );
  const featureSelected: Feature | undefined = useAppSelector(
    selectFeatureSelected,
  );
  const mode: FeatureSelectedMode = useAppSelector(
    selectFeatureSelectedMode,
  );
  const dispatch = useAppDispatch();

  const polygons = useMemo(() => features.filter(f => ['MultiPolygon', 'Polygon'].includes(f.geometry.type)), [features]);
  const lines = useMemo(() => features.filter(f => ['MultiLineString', 'LineString'].includes(f.geometry.type)), [features]);
  const points = useMemo(() => features.filter(f => ['MultiPoint', 'Point'].includes(f.geometry.type)), [features]);

  return (
    <div>
      {
        featureSelected && mode === 'remove' ? (
          <Marker longitude={getTopRightCoordinate(featureSelected)[0]} latitude={getTopRightCoordinate(featureSelected)[1]}>
            <div
              className={
                'at-map-cm-geometries__delete-container ' +
                (mode === 'remove' ? 'selected' : '')
              }
            >
              <Button
                className={'at-map-cm-geometries__delete '}
                size='large'
                shape='round'
                onClick={(e) => {
                  dispatch(removeFeatureSelected());
                  e.stopPropagation();
                }}
                type={'default'}
                icon={<Icon component={Remove} />}
              >Quitar de la tarea</Button>
            </div>
          </Marker>
        ) : null
      }

      <Source id={'MapCMGeometrySource-poligons'}
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: polygons as any,
              }}
      >

        <Layer beforeId={'order-polygon'} id={'cm_geometry-polygons'} type={'fill'} paint={{
          'fill-color': process.env.REACT_APP_GEOMETRIA_CM_COLOR,
          'fill-opacity': 0.2,
        }}
        />
        <Layer beforeId={'order-polygon'} id={'cm_geometry_line-poligons'} type={'line'} paint={{
          'line-color': process.env.REACT_APP_GEOMETRIA_CM_COLOR,
          'line-width': 3,
        }}
        />
      </Source>
      <Source id={'MapCMGeometrySource-lines'}
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: lines as any,
              }}
      >

        <Layer beforeId={'order-polygon'} id={'cm_geometry-lines'} type={'line'} paint={{
          'line-color': process.env.REACT_APP_GEOMETRIA_CM_COLOR,
          'line-width': 3,
        }}
        />
      </Source>
      <Source id={'MapCMGeometrySource-points'}
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: points as any,
              }}
      >

        <Layer beforeId={'order-polygon'} id={'cm_geometry-points'} type={'circle'} paint={{
          'circle-color': process.env.REACT_APP_GEOMETRIA_CM_COLOR,
          'circle-radius': 6,
          'circle-stroke-color': 'white',
          'circle-stroke-width': 2,
        }}
        />
      </Source>
    </div>
  );
}

export default MapCMGeometries;
